import { ajaxWatchRequest, ajaxUnwatchRequest } from './actions/ajax';
import { uxRedirect } from "./actions/ux";
import { userAuthenticated } from "./actions/user";

export function ajaxWatched(requestPromise) {
    var requestToken = {};
    return (dispatch, getState) => {
        dispatch(ajaxWatchRequest(requestToken));
        return requestPromise
            .finally(() => dispatch(ajaxUnwatchRequest(requestToken)));
    }
}

function returnJsonIfOk(response) {
    if (response.ok) {
        return response.json();
    } else {
        throw response;
    }
}

function updateAuthInfoIfPresent(dispatch) {
    return (response) => {
        let authInfo = response.headers.get('Set-Auth-Info');
        if (authInfo != null) {
            authInfo = JSON.parse(authInfo);
            dispatch(userAuthenticated(authInfo));
        }

        return response;
    }
}

export function apiRequest(dispatch, getState, resource, init={}){
    let opts = {...{
        'headers': { 'Content-Type': 'application/json' },
        'credentials': 'include',
        'method': 'GET'
    }, ...init};

    if (opts.headers.Authorization === undefined){
        try {
            let authToken = getState().user.authToken;
            if (authToken !== null) {
                opts.headers['Authorization'] = 'Basic ' + btoa('ISSUED_TOKEN:' + authToken)
            }
        } catch (Exception) { }
    }

    let serviceUrl = '';
    if (process.env.NODE_ENV == 'development'){
        serviceUrl = '//localhost:5000';
    }
    return fetch(serviceUrl + resource, opts)
        .then(updateAuthInfoIfPresent(dispatch))
        .then(returnJsonIfOk)
        .catch(response => {
            switch (response.status)
            {
                case 403:
                    dispatch(uxRedirect('/app/common/unauthorized'));
                    return Promise.reject();
                default:
                    dispatch(uxRedirect('/app/common/error'));
                    return Promise.reject();
            }
        });
}